module.exports = __webpack_public_path__ + "img/root11.98c6aa0b.png";